import {
    AfterViewInit,
    Component,
    OnInit,
    ViewChild,
} from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DashboardBizzDevService } from "../../../../shared/services/dashboard-bizz-dev.service";
import { Router } from "@angular/router";
import {
    Cities
} from "../../../../shared/models/classes/Dashboard/cityData/city-data";

@Component({
    selector: "app-bxl-cities",
    templateUrl: "./bxl-cities.component.html",
    styleUrls: ["./bxl-cities.component.scss"],
})
export class BxlCitiesComponent implements OnInit, AfterViewInit {
    constructor(
        private dashboardService: DashboardBizzDevService,
        private router: Router
    ) {}

    sicbxlCitiesDataYear: Cities;
    displayedColumns = [
        "fullLabel",
        "lastRealizedYear",
        "lastBudgetedYear",
        "importDate",
        "licenceType",
        "lastConnexionDate",
    ];
    dataSource;
    @ViewChild(MatSort)
    sort: MatSort;

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        this.GetSICBXLRBYear();
    }

    GetSICBXLRBYear(): void {
        this.dashboardService.getCityData("sicbxl").subscribe((value) => {
            this.dataSource = new MatTableDataSource(value);
            this.sicbxlCitiesDataYear = value;
            if (this.sort) {
                this.dataSource.sort = this.sort;
            }
        });
    }

    doFilter = (value: string) => {
        this.dataSource.filter = value.trim().toLocaleLowerCase();
    };
    loadCityDetails(id: number) {
        this.router.navigate(["/dashboardBizzDev/details/cityDetails", id]);
    }
}
